import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

const KnowyourCarb = () => {
  const { blendName } = useParams();
  const [activeBlend, setActiveBlend] = useState("Carbohydrate");

  const blends = [
    { name: "Carbohydrate", contentId: "carbohydrate" },
    { name: "Protein", contentId: "protein" },
    { name: "Fat", contentId: "fat" },
    { name: "Vitamin", contentId: "vitamin" },
    { name: "Fiber", contentId: "fiber" },
  ];

  useEffect(() => {
    // Set the active blend based on the blendName from the URL or fallback to default
    const blend = blends.find(
      (b) => b.name.toLowerCase() === blendName?.toLowerCase()
    );
    setActiveBlend(blend ? blend.name : "Carbohydrate");
  }, [blendName]);

  return (
    <section className="fresh-vegetable-section section-lg-space">
      <div className="container-fluid-lg">
        <div className="row">
          {/* Left Column */}
          <div className="col-xl-4 font-smd mb-3">
            <div className="width_75">
              {blends.map((blend, index) => (
                <div
                  key={index}
                  className={`mb-3 font-smd boder-radius-twenty ${
                    activeBlend === blend.name
                      ? "active_background_white fw-semibold"
                      : "grey_non_active fw-semibold"
                  }`}
                  onClick={() => setActiveBlend(blend.name)}
                  style={{
                    position: "relative",
                    cursor: "pointer",
                  }}
                >
                  {blend.name} blend
                  {activeBlend === blend.name && (
                    <hr
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        bottom: 0,
                        opacity: 1,
                        height: "100%",
                        borderLeft: "5px solid var(--theme-color)",
                        margin: 0,
                      }}
                    />
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Right Column */}
          <div className="col-xl-8">
            {/* Carbohydrate Content */}
            {activeBlend === "Carbohydrate" && (
              <div id="carbohydrate" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Carbohydrate <br></br>Blend</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1{")"} Do we have good and bad carbohydrates like good and
                      bad lipids (fat)?
                    </div>
                    <p className="font-xsm justify_content">
                      Yes. For simplicity, Carbohydrates are broadly classified
                      as REFINED (Bad) and COMPLEX (Good) carbohydrates
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2{")"} What is ‘Healthy Carbohydrate’ blend in Reducarb?
                    </div>
                    <p className="font-xsm justify_content">
                      Carbohydrates are main source of energy in normal
                      conditions. When you eat any type of carbohydrates, they
                      are broken down into glucose and it enters your
                      bloodstream. This increases blood sugar levels. The
                      hormone insulin helps the cells in your body to take up
                      this glucose and use it for energy. Though, carbohydrates
                      increase sugar that does not mean, you should hold / avoid
                      carbohydrates.  The most important factor in controlling
                      blood sugar is the<br></br>A{"]"} amount of carbohydrates
                      eaten in a meal and<br></br>B{"]"} other food items eaten
                      along with it.<br></br>
                      Reducarb provides LOW QUANTITY of carbohydrates per serve
                      and thus helps in reducing daily carbohydrate consumption
                      when used as a meal replacement. Qualitatively, it has
                      HEALTHY CARBOHYDRATE INDICES <br></br>a{")"} Product
                      should have more than 1gm fiber per 10 gm of carbohydrates
                      <br></br>b{")"}  Product should
                      have {"<"}2gm of free sugars per 1gm of fibers<br></br>
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      3) What is Low carbohydrate meal? How are they classified?
                    </div>
                    <p className="font-xsm justify_content">
                      Defining low-carbohydrate diets is difficult because there
                      is no consistent definition. In a recently published
                      systematic review published by the American Diabetic
                      Association definitions for very-low-carbohydrate diet{" "}
                      {"("}
                      {"<"}10% of daily calories from carbohydrates{")"} {"("}
                      generally referred as Keto Diets{")"} and moderately
                      low-carbohydrate {"("}30 to {"<"} 40% of daily calories
                      from carbohydrates{")"} were suggested. Reducarb provide
                      around {"("}34-35% calories from carbohydrate per serve
                      {")"}. Hence, it is moderately low carbohydrate meal
                      replacement.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      4) What are the advantages of Low Carbohydrate meal plans?
                    </div>
                    <p className="font-xsm justify_content">
                      Low carbohydrate approach has multiple advantages:
                      <br></br>a{")"} It reduces blood glucose, forcing your
                      body to rely on energy sources other than carbohydrates
                      and cuts your appetite. This is reflected in a reduction
                      of HbA1c, fasting, and post-lunch blood glucose.<br></br>b
                      {")"} Eating fewer carbs reduces the burden on the
                      pancreas and lowers insulin resistance independent of
                      weight loss.<br></br>c{")"} In pre-diabetes, a low
                      carbohydrate approach has shown to postpone the onset of
                      frank diabetes and/or reversal of pre-diabetes.<br></br>d
                      {")"} In overweight and obese people, it promotes weight
                      reduction and helps in maintaining reduced weight.
                      <br></br>e{")"} In people with metabolic syndrome {"("}
                      risk of diabetes and/or heart diseases{")"}, the low
                      carbohydrate approach helps in improving lipids, sugar
                      profiles, and reducing weight. This improves your health
                      and reduces the risk of future diabetes and/or heart
                      diseases.
                    </p>
                  </div>
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      Not everyone will be willing or able to cut their
                      carbohydrate intake. But cutting even some carbs might
                      lead to blood sugar and weight control benefits
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Protein Content */}
            {activeBlend === "Protein" && (
              <div id="protein" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Protein Blend</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1) What is dual protein blend in Reducarb?
                    </div>
                    <p className="font-xsm justify_content">
                      Reducarb has whey and soy source protein blend. Soy and
                      whey proteins have demonstrated multiple benefits in
                      people with pre-diabetes, Type 2 diabetes mellitus, and
                      overweight and obese people undergoing weight management
                      protocols.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2) Which is plant protein in dual protein blend?
                    </div>
                    <p className="font-xsm justify_content">
                      Reducarb has soy proteins which are plant-based. Research
                      has shown that replacing some animal protein with soy
                      protein may lead to improvements in cardiovascular
                      disease risk factors, with no changes in renal function.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      3) Do soy proteins help in post-menopausal overweight women?
                    </div>
                    <p className="font-xsm justify_content">
                      Indeed, a recent study in 15 postmenopausal women with
                      abdominal obesity showed that partially replacing animal
                      proteins with soy-based foods improved insulin sensitivity{" "}
                      {"("}action of sugar-lowering hormone; insulin{")"}.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      4) Do soy proteins help in prevention of diabetes?
                    </div>
                    <p className="font-xsm justify_content">
                      A large meta-analysis published in the American Journal of
                      Clinical Nutrition has concluded that dietary intakes of
                      tofu, soy protein, and soy isoflavones are inversely
                      associated with incidence of type 2 diabetes. This supports
                      recommendations to increase intakes of certain soy
                      products for the prevention of type 2 diabetes.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      5) Does soy intake help in reducing heart risk?
                    </div>
                    <p className="font-xsm justify_content">
                      Yes!! Indeed. One recently published meta-analysis
                      demonstrated that soy consumption reduces the risks of
                      diabetes and heart disease, and a specific quantity of soy
                      products was the most beneficial for prevention.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      6) Does soy intake help in managing higher lipids?
                    </div>
                    <p className="font-xsm justify_content">
                      Soy does not contain cholesterol, but its plant
                      components, including lecithin, stigmasterol, soy protein
                      peptides, and isoflavones, improve lipid profiles through
                      different mechanisms.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      7) Does whey protein source beneficial in combating
                      pre-diabetes and obesity?
                    </div>
                    <p className="font-xsm justify_content">
                      Consumption of milk and dairy products has been associated
                      with reduced risk of metabolic disorders and
                      cardiovascular disease. Recently, the beneficial
                      physiological effects of whey protein on the control of
                      food intake and glucose metabolism have been reported.
                      Whey protein, via bioactive peptides and amino acids
                      generated during gastrointestinal digestion, enhances the
                      release of several hormones, leading to reduced food
                      intake and increased satiety. The induced satiety and
                      blood glucose reduction support the application of whey
                      protein intake in managing Type 2 diabetes and obesity.{" "}
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Fat Content */}
            {activeBlend === "Fat" && (
              <div id="fat" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Fat Blend</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1) What is the fat source in Reducarb?
                    </div>
                    <p className="font-xsm justify_content">
                      Reducarb contains Oleic acid as a fat source. It is rich
                      in Polyunsaturated Fatty Acids (PUFA) and Monounsaturated
                      Fatty Acids (MUFA). PUFA and MUFA are known for their
                      heart-protective action. They reduce the chances of
                      accumulation of fat in the blood vessels, thus helping
                      seamless blood flow to vital organs.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2) Is it a rich source of PUFA and MUFA?
                    </div>
                    <p className="font-xsm">
                      Yes. It has 8.5 /100g gm of MUFA {"("}Reducarb Him{")"}{" "}
                      and 7.3/100gm PUFA {"("}Reducarb Her{")"}.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      3) Does it contain saturated fat or trans fat?
                    </div>
                    <p className="font-xsm">
                      No. Utmost care has been taken to avoid saturated and
                      trans fat in Reducarb. Their levels are negligible, making
                      it very safe.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      4) Which is the key fatty acid source in Reducarb?
                    </div>
                    <p className="font-xsm justify_content">
                      Reducarb is a good source of Linoleic acid {"(>"}4% energy
                      contribution from Linoleic acid{")"}. Linoleic acid is
                      known for its beneficial role in preventing diabetes and
                      metabolic disorders.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Vitamin Content */}
            {activeBlend === "Vitamin" && (
              <div id="vitamin" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Vitamin Blend</h1>
                  </div>
                </div>

                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1) Does it cover all my vitamin and mineral needs?
                    </div>
                    <p className="font-xsm justify_content">
                      Reducarb is a one or more meal replacement formula and not
                      to replace all meals of the day. Generally, vitamin and
                      mineral deficiencies are not seen in short-term use.
                      Further, Reducarb contains key vitamins and minerals up to
                      50% RDAs. Please consult a dietician/healthcare personnel
                      for long-term use.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2) Does it provide an adequate amount of key vitamins
                      generally deficient in Indian people?
                    </div>
                    <p className="font-xsm justify_content">
                      Yes. The utmost care has been taken to provide 50% RDA of
                      key vitamins like Vit B12, folic acid, Vit C, Vit A, and
                      Vit D. It also provides 50% RDA of minerals like iron and
                      30% RDA of calcium. It is also a good source of Vit B1,
                      B2, B3, and B6.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {/* Fiber Content */}
            {activeBlend === "Fiber" && (
              <div id="fiber" className="content-section">
                <div
                  className="custom-image-container text-white reducarb-blends-images background_blue_section_Know_your fresh-image-2 d-flex justify-content-start align-items-center "
                  style={{
                    backgroundImage:
                      "url('../assets/images/ReducarbBlends/reducarb-blends_banner.jpg')",
                  }}
                >
                  <div>
                    <h1 className="font-lg mb-3">Fiber Blend</h1>
                  </div>
                </div>
                <div className="mt-3">
                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      1) What is the fiber source in Recucarb?
                    </div>
                    <p className="font-xsm">
                      Reducarb contains Resistant Maltodextrin (also known as
                      Fibersol) as a fiber source.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      2) Does it provide high fibers?
                    </div>
                    <p className="font-xsm">
                      Yes. Reducarb is designed with high and complex fibers
                      optimising carbohydrate : fiber ratio.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      3) What is the advantage of optimal carbohydrate : fiber
                      ratio?
                    </div>
                    <p className="font-xsm justify_content">
                      Optimal carbohydrate : fiber ratio helps in reducing extent
                      and rate of sugar absorption. This avoids sugar spikes,
                      improvs insulin sensitivity and reverses pre-diabetes.
                    </p>
                  </div>

                  <div>
                    <div className="font-sm mb-1 fw-semibold">
                      4) What are advantages of high fibers?
                    </div>
                    <p className="font-xsm justify_content">
                      Fibers are known to reduce extent and rate of carbohydrate
                      (esp refined sugar) absorption. It helps in reducing sugar
                      spikes, improves insulin sensitivity and overall metabolic
                      profile. Fibers are also known to give early satiety and hence are
                      key for weight reduction. After metabolic degradation, fibers offers key products
                      (called as Short Chain Fatty Acids, SCFA) which are eaten
                      up by GOOD bacteria in our intestine. This helps improving
                      gut health, digestion and bowel habits
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default KnowyourCarb;
